import React, { useContext, useEffect, useRef, useState } from "react";
import Hamburger from "../../../../images/AnimatedHamburger.svg";
import LocateAsset from "../../../../images/LocateAsset.svg";
import Loading from "../../../../images/Loading.gif";
import DownArrow from "../../../../images/DownArrow.svg";
import SubsidiarySelect from "../../../../customComponents/SubsidiarySelect";
import { MapsContext } from "./context/context";
import { mapsPayloadType } from "./context/reducer";
import { EMPTY_STRING, emptyFunc } from "../../../../utils/constants";
import CompaniesAutocomplete from "../../customer/companies/CompaniesAutocomplete";
import useUrlParams from "../../../../customHooks/useUrlParams";

import {
  AtsStckItemDetailsEdges,
  AtsStckItemEdge,
  AtsStckItemOrderField,
  GetDataForMapsData,
  GetDataForMapsVars,
  GetItemsResult,
  GetItemsVars,
  ItemQueryType,
} from "../masters/items/queries/types";
import { useLazyQuery } from "@apollo/client";
import { GetDataForMaps, GetItems } from "../masters/items/queries/queries";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import Navbar from "../../../common/layout/Navbar";
import MyMaps from "./MyMaps";
import ItemDetailsComp from "./ItemDetailsComp";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { APIProvider } from "@vis.gl/react-google-maps";
import { MapAutocomplete } from "./MapAutocomplete";
import Tabs, { TabType } from "./customComponents/Tabs";
import { GetSubsidiarySites } from "../masters/subsidary/queries/queries";
import {
  AtsSubsidiarySiteOrderField,
  GetSubsidiarySitesResult,
  GetSubsidiarySitesVar,
} from "../masters/subsidary/queries/types";
import useLabels from "../../../../customHooks/useLabels";
import { CustomModal } from "../../../../utils/UtilFunctions";
import {
  ViewAssetStyles,
  ViewModalStyles,
} from "../../../../styles/CustomModalStyles";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import JunctionsAutocomplete from "../../../../customComponents/JunctionsAutocomplete";
import SiteSelect from "../../../../customComponents/SiteSelect";
import Add from "../../../../images/UnCollapse.svg";
import { CustomDrawerInMaps } from "../../../../styles/CustomDrawerStyles";
import RightArrow from "../../../../images/ArrowRight.svg";
import { TableType } from "../../customer/companies/queries/types";
import { TicketStatusOptionsTypes } from "../../../../utils/types";
import MultipleTicketStatusSelect from "../../../../customComponents/MultipleTicketStatusSelect";
import JunctionLevelTicketing from "./ticketing/junctionDetails/JunctionIndex";
import RaisedTicketDetailsJunctionLevel from "./ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import TableTypeAutocomplete, {
  tableTypeOptions,
} from "../../../../customComponents/TableTypeAutocomplete";
import { NavTypeProps } from "./MapsIndex";
import { AssetDetailsPageFor } from "./ticketing/junctionDetails/raisedTickets/AssetDetails";
import Input from "../../../../stories/Input/Input";

export interface StateTypes {
  itemId: number;
  tableLevel: TableType;

  flag: boolean;
}
const Maps = ({ NavType, pageFor }: NavTypeProps) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const { state, dispatch } = useContext(MapsContext);
  const { customer_id, company_id, sub_id, siteID, junctionID } =
    useUrlParams();
  const [statusSelected, setStatusSelected] = useState<
    TicketStatusOptionsTypes[]
  >([]);
  const [addDrawer, setAddDrawer] = useState(false);

  const clusterer = useRef<MarkerClusterer | null>(null);
  const [assetDetails, setAssetdetails] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });
  const [raisedTicketModal, setRaisedTicketModal] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });

  const [junctionLevelRaisedTicketModal, setJunctionLevelRaisedTicketModal] =
    useState<StateTypes>({
      itemId: 0,
      flag: false,
      tableLevel: TableType.COMPANY,
    });
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [items, setItems] = useState<AtsStckItemEdge[]>([]);
  const [itmDetails, setItmDetails] = useState<AtsStckItemDetailsEdges[]>([]);
  const [searchItem, setSearchItem] = useState("");

  const [tableType, setTableType] = useState<tableTypeOptions>({
    label: "Junction",
    value: TableType.JUNCTION,
  });

  const { user_details } = useLoggedInUserDetails();
  const [searchCoordinates, setSearchCoordinates] = useState("");
  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null);

  const [GetStockItems, { data, loading }] = useLazyQuery<
    GetItemsResult,
    GetItemsVars
  >(GetItems);

  const [GetSites, { data: sitesData }] = useLazyQuery<
    GetSubsidiarySitesResult,
    GetSubsidiarySitesVar
  >(GetSubsidiarySites);

  const [
    GetItmDetails,
    { data: itemDetailsData, loading: itemDetailsLoading, error },
  ] = useLazyQuery<GetDataForMapsData, GetDataForMapsVars>(GetDataForMaps, {
    pollInterval: 20000,
  });

  const clearMarkers = () => {
    clusterer.current?.clearMarkers();
  };
  useEffect(() => {
    if (customer_id || company_id) {
      GetStockItems({
        variables: {
          after: null,
          customerID: customer_id ? customer_id : 0,
          companyID: company_id ? company_id : 0,
          first: null,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckItemOrderField.DESC,
          },

          name: EMPTY_STRING,
          hsnCode: EMPTY_STRING,
          input: {
            query_type: ItemQueryType.All,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckUomID: 0,
            stckSubCategoryID: 0,
            ldgrID: 0,
            subsidiaryID: state.subsidary ? state.subsidary.node.id : 0,
            isComponent: undefined,
          },
        },
      });
    } else {
      setItems([]);
    }
  }, [customer_id, state.company, state.subsidary, GetStockItems, searchItem]);

  useEffect(() => {
    if (customer_id || company_id) {
      GetSites({
        variables: {
          after: null,
          customerID: customer_id ? customer_id : 0,
          companyID: company_id ? company_id : 0,
          empID: user_details.id,
          first: null,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsSubsidiarySiteOrderField.NAME,
          },

          name: EMPTY_STRING,
          subsidiaryID: sub_id ? sub_id : 0,
        },
      });
    } else {
      setItems([]);
    }
  }, [customer_id, state.company, state.subsidary, GetStockItems, searchItem]);
  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItems.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (company) => company.node.id === newCompany.node.id,
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetItems.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    if (customer_id) {
      GetItmDetails({
        variables: {
          customerID: customer_id ? customer_id : 0,

          input: {
            id: 0,
            idType: TableType.CUSTOMER,
            retTableType: TableType.ASSET,
            ticketStatus: statusSelected.length
              ? Object.values(statusSelected.map(({ value }) => value))
              : [],
            empID: user_details.id,
            jType: [],
            LdgrIds: [],
            priority: [],
            itemID: 0,
          },
        },
      });
    } else {
      setItems([]);
    }
  }, [
    customer_id,
    state.company,
    state.subsidary,
    GetItems,
    statusSelected,
    searchItem,
    user_details.id,
  ]);

  const {
    subsidiaryLabel,
    itemLabel,
    companyLabel,
    junctionLabel,
    subsidiarySiteLabel,
  } = useLabels();
  return (
    <>
      <Navbar NavType={NavType} />
      <APIProvider apiKey={process.env.React_App_MAP!}>
        {loading ? (
          <div className="loading-container">
            <img src={Loading} alt="loading" className="loading-gif" />
          </div>
        ) : (
          <div className="maps">
            <div className="maps__flex">
              <MyMaps
                items={itemDetailsData ? itemDetailsData.GetDataForMaps : []}
                clusterer={clusterer}
                pageFor={pageFor}
                selectedPlace={selectedPlace}
                sub_sites={sitesData ? sitesData.GetSubsidiarySites.edges : []}
                setAssetdetails={setAssetdetails}
                setRaisedTicketDetails={setRaisedTicketModal}
                assetType={tableType?.value!}
                setJunctionLevelRaisedTicketModal={
                  setJunctionLevelRaisedTicketModal
                }
                searchCoordinates={searchCoordinates}
              />

              <div className="maps__flex--left">
                <input type="checkbox" id="total-asset" name="" />

                {loading ? (
                  <img src={Loading} alt="loading" className="loading-gif" />
                ) : (
                  <>
                    {/* <div className="maps__flex--input">
                      <Input
                        id="data_search"
                        placeholder="Search..."
                        onChange={(e) => {
                          setSearchItem(e.target.value);
                        }}
                      />
                    </div> */}
                    {/* <div className="maps__flex--left--hamburger">
                      <label htmlFor="total-asset">
                        <img src={Hamburger} alt="/" id="toggle" />
                      </label>
                    </div> */}
                    <div className="maps__flex--left--total-items">
                      <b>Total {itemLabel}</b>
                      <div className="maps__flex--left--total-items--flex">
                        <span>
                          {itemDetailsData
                            ? itemDetailsData.GetDataForMaps.length
                            : 0}
                        </span>
                        <img src={LocateAsset} alt="" />
                      </div>
                    </div>

                    <div className="maps__flex--left--asset">
                      <div className="maps__flex--left--total">
                        <b>Total {itemLabel}</b>
                        <div>
                          <span>{data ? data.GetItems.totalCount : 0}</span>
                          <img src={LocateAsset} alt="" />
                        </div>
                      </div>
                      <div className="maps__flex--left--asset--list">
                        <ul className="maps__flex--left--asset--list--main">
                          {items.map((res, index) => {
                            return (
                              <React.Fragment key={index}>
                                <li
                                  className="maps__flex--left--asset--main"
                                  onClick={() => {
                                    if (expandedIndex === index) {
                                      dispatch({
                                        type: mapsPayloadType.ITEM,
                                        payload: {
                                          item: null,
                                        },
                                      });
                                    } else {
                                      dispatch({
                                        type: mapsPayloadType.ITEM,
                                        payload: {
                                          item: res.node,
                                        },
                                      });
                                    }
                                    clearMarkers();
                                    setExpandedIndex(
                                      expandedIndex === index ? null : index,
                                    );
                                  }}
                                >
                                  <b>{res.node.desc}</b>
                                  <div>
                                    <img src={LocateAsset} alt="" />
                                    <img
                                      src={DownArrow}
                                      alt=""
                                      style={{
                                        transform: `${
                                          expandedIndex === index
                                            ? "rotate(0deg)"
                                            : "rotate(-90deg)"
                                        }`,
                                      }}
                                    />
                                  </div>
                                </li>
                                {expandedIndex === index && (
                                  <ItemDetailsComp itemDetails={itmDetails} />
                                )}
                              </React.Fragment>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="maps__flex--right">
                <div className="maps__flex--right--header">
                  <div className="maps__flex--right--header--filters">
                    <input type="checkbox" id="filters" name="" />
                    <div className="maps__flex--right--filter">
                      <label htmlFor="filters">
                        <img src={RightArrow} alt="/" id="toggle" />
                      </label>
                    </div>
                    <div className="maps__flex--right--header--filters--bg">
                      <div className="maps__flex--right--flex">
                        <TableTypeAutocomplete
                          onChange={(newValue) => {
                            clearMarkers();
                            if (newValue) {
                              setTableType(newValue);
                            } else {
                              setTableType({
                                label: "Junction",
                                value: TableType.JUNCTION,
                              });
                            }
                          }}
                          onKeyDown={emptyFunc}
                          placeholder="Table Type"
                          value={tableType.value}
                        />
                      </div>
                      {company_id ? null : (
                        <div className="maps__flex--right--flex">
                          <CompaniesAutocomplete
                            onChange={(newValue) => {
                              clearMarkers();
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.COMPANY,
                                  payload: {
                                    company: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.COMPANY,
                                  payload: {
                                    company: null,
                                  },
                                });
                              }
                            }}
                            onKeyDown={emptyFunc}
                            placeholder={companyLabel}
                            value={state.company ? state.company.node.id : 0}
                          />
                        </div>
                      )}
                      {sub_id ? null : (
                        <div className="maps__flex--right--flex">
                          <SubsidiarySelect
                            onChange={(newValue) => {
                              clearMarkers();
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.SUBSIDARY,
                                  payload: {
                                    subsidary: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.SUBSIDARY,
                                  payload: {
                                    subsidary: null,
                                  },
                                });
                                dispatch({
                                  type: mapsPayloadType.SITE,
                                  payload: {
                                    site: null,
                                  },
                                });
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: null,
                                  },
                                });
                              }
                            }}
                            label=""
                            companyID={
                              company_id
                                ? company_id
                                : state.company
                                  ? state.company.node.id
                                  : 0
                            }
                            onKeyDown={emptyFunc}
                            value={
                              state.subsidary ? state.subsidary.node.id : 0
                            }
                            placeholder={subsidiaryLabel}
                          />
                        </div>
                      )}
                      {!siteID ? (
                        <div className="maps__flex--right--flex">
                          <SiteSelect
                            onChange={(newValue) => {
                              clearMarkers();
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.SITE,
                                  payload: {
                                    site: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.SITE,
                                  payload: {
                                    site: null,
                                  },
                                });
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: null,
                                  },
                                });
                              }
                            }}
                            label=""
                            companyId={
                              company_id
                                ? company_id
                                : state.company
                                  ? state.company.node.id
                                  : 0
                            }
                            subsidiaryId={
                              sub_id
                                ? sub_id
                                : state.subsidary
                                  ? state.subsidary.node.id
                                  : 0
                            }
                            onKeyDown={emptyFunc}
                            value={state.site ? state.site.value : 0}
                            placeholder={subsidiarySiteLabel}
                          />
                        </div>
                      ) : null}

                      {!junctionID ? (
                        <div className="maps__flex--right--flex">
                          <JunctionsAutocomplete
                            onChange={(newValue) => {
                              clearMarkers();
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: null,
                                  },
                                });
                              }
                            }}
                            label=""
                            companyID={
                              company_id
                                ? company_id
                                : state.company
                                  ? state.company.node.id
                                  : 0
                            }
                            subsidiaryID={
                              sub_id
                                ? sub_id
                                : state.subsidary
                                  ? state.subsidary.node.id
                                  : 0
                            }
                            siteID={state.site ? state.site.value : 0}
                            onKeyDown={emptyFunc}
                            value={state.junction ? state.junction.node.id : 0}
                            placeholder={junctionLabel}
                          />
                        </div>
                      ) : null}
                      <div className="maps__flex--right--flex">
                        <MultipleTicketStatusSelect
                          onChange={(newValue) => {
                            clearMarkers();
                            setStatusSelected(newValue);
                          }}
                          onKeyDown={emptyFunc}
                          value={[]}
                          handleClear={emptyFunc}
                          label=""
                          placeholder="Ticket Status"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="maps__search">
                    <Input
                      id="data_search"
                      placeholder="Lat,Lng..."
                      onChange={(e) => {
                        setSelectedPlace(null);
                        setSearchCoordinates(e.target.value);
                      }}
                    />
                  </div>
                  <MapAutocomplete onPlaceSelect={setSelectedPlace} />
                </div>
                <div
                  className="maps__flex--right--tabs"
                  onClick={() => setAddDrawer(!addDrawer)}
                >
                  <img src={Add} alt="/" />
                </div>
              </div>
            </div>
            <CustomModal
              style={ViewAssetStyles}
              isOpen={assetDetails.flag}
              onRequestClose={() =>
                setAssetdetails({
                  flag: false,
                  itemId: 0,
                  tableLevel: TableType.COMPANY,
                })
              }
              contentComponent={
                // <Ticketing
                //   setModalFlag={() =>
                //     setAssetdetails({
                //       flag: false,
                //       itemId: 0,
                //     })
                //   }
                //   showRaiseTicket
                // />
                <JunctionLevelTicketing
                  setModalFlag={() =>
                    setAssetdetails({
                      flag: false,
                      itemId: 0,
                      tableLevel: TableType.COMPANY,
                    })
                  }
                  assetType={TableType.ASSET}
                  showRaiseTicket
                />
              }
            />

            {/* <CustomModal
              style={ViewModalStyles}
              isOpen={raisedTicketModal.flag}
              onRequestClose={() =>
                setRaisedTicketModal({
                  flag: false,
                  itemId: 0,
                })
              }
              contentComponent={
                <RaisedTicketDetails
                  setModalFlag={() =>
                    setRaisedTicketModal({
                      flag: false,
                      itemId: 0,
                    })
                  }
                />
              }
            /> */}

            <CustomModal
              style={ViewModalStyles}
              isOpen={junctionLevelRaisedTicketModal.flag}
              onRequestClose={() =>
                setJunctionLevelRaisedTicketModal({
                  flag: false,
                  itemId: 0,
                  tableLevel: TableType.COMPANY,
                })
              }
              contentComponent={
                <RaisedTicketDetailsJunctionLevel
                  setModalFlag={() =>
                    setJunctionLevelRaisedTicketModal({
                      flag: false,
                      itemId: 0,
                      tableLevel: TableType.COMPANY,
                    })
                  }
                  pageFor={AssetDetailsPageFor.MAPS}
                  assetType={TableType.JUNCTION}
                />
              }
            />
            <CustomDrawerInMaps
              anchor="right"
              open={addDrawer}
              onClose={() => setAddDrawer(!addDrawer)}
            >
              <Tabs active={TabType.MAP} pageFor={pageFor} />
            </CustomDrawerInMaps>
          </div>
        )}
      </APIProvider>
    </>
  );
};

export default Maps;
